module.exports = __webpack_public_path__ + "img/digital-unlock.faa87c42.png";